import { useState, useEffect, useRef } from "react";
import { Typography, Space, Input, Button, Spin, App } from "antd";
import {
  CloseOutlined,
  FolderAddOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import { createFolder } from "@/api/definitionsMenu";

const CreateFolder = ({ parent, onChangeFolder }) => {
  const { message } = App.useApp();
  const [isEdit, setIsEdit] = useState(false);
  const [name, setName] = useState("");

  const [pending, setPending] = useState(false);

  const inputRef = useRef();

  useEffect(() => {
    if (isEdit && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEdit]);

  const onSave = async () => {
    if (!name) {
      return;
    }

    setPending(true);

    try {
      await createFolder({ name, parent });

      await onChangeFolder();
      setName("");
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setPending(false);
    }
    setIsEdit(false);
  };

  return (
    <>
      {isEdit ? (
        <Spin spinning={pending} style={{ display: "inline-block" }}>
          <Space
            style={{
              background: "var(--color-white)",
              marginInline: "-4px",
              paddingInline: "4px",
            }}
          >
            <Input
              ref={inputRef}
              size="small"
              placeholder="Название группы"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <div>
              <Button
                size="small"
                type="link"
                icon={<SaveOutlined />}
                onClick={onSave}
              ></Button>
              <Button
                size="small"
                type="link"
                icon={<CloseOutlined />}
                onClick={() => setIsEdit(false)}
              ></Button>
            </div>
          </Space>
        </Spin>
      ) : (
        <Typography.Link
          style={{ paddingInline: "5px" }}
          onClick={() => setIsEdit(true)}
        >
          <Space>
            <FolderAddOutlined />
            Создать папку
          </Space>
        </Typography.Link>
      )}
    </>
  );
};

export default CreateFolder;
